import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import amazon from "../logos/amazon1.jpg";
export default function Navbar(props) {
  return (
    <div className="navbar">
      <NavLink to="" className="nav-link">
        <img src={amazon} alt="" className="amazon-img" />
      </NavLink>
      <NavLink to="" className="nav-link active">
        Home
      </NavLink>
      <NavLink to="/about" className="nav-link">
        About
      </NavLink>
      <NavLink to="/products" className="nav-link">
        Products
      </NavLink>
      <div id="nav-link-merged">
        <NavLink to="/login" className="nav-link">
          Login
        </NavLink>
        <span className="nav-link">/</span>
        <NavLink to="/signup" className="nav-link">
          Sign Up
        </NavLink>
      </div>
      <NavLink to="/cart" className="nav-link">
        <i className="fa fa-shopping-cart cart"></i>
        <span className="counter">{props.counter}</span>
      </NavLink>
      <Outlet />
    </div>
  );
}
